module.exports = __webpack_public_path__ + "img/havannaoak696l_detail_rsh5.9118fa8c.jpg";